import { useAtom } from 'jotai'
import useBaseApiHook, { BASE_API_CONSTANT } from 'services/useBaseApiHook'
import { currentProfileAtom } from 'store/currentUser/currentUserAtom'
import { isRoleRADAtom } from 'store/isRoleRAD/isRoleRADAtom'
import LocalStorageUtils from 'utils/LocalStorage'
import { errorToast } from 'utils/Toast'

const REPO_URL = {
  login: '/authenticate',
  chooseProfile: '/mst/user-login/token',
  logout: '/logout-account',
  checkToken: '/mst/user-login/check-token',
  // login: '/auth/auth-response-success.json',
  // login: '/users',
  loginFailed: '/auth/auth-response-failed.json'
}

const useAuthRepo = (initialLoading = false) => {
  const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading, true)
  const { executeApi: executeApiWithoutErrorShown } = useBaseApiHook(initialLoading, false)
  const [currentProfile] = useAtom(currentProfileAtom)
  const [_, setIsRoleRAD] = useAtom(isRoleRADAtom)

  const login = async (username, password) => {
    // for EMPLOYEEE USER, username length always 10
    // let make_password_uppercase = username.length >= 10 ? password.toLowerCase().toUpperCase() : password

    const payload = {
      username,
      password
    }

    // if(username !== 'admin' || password !== 'admin') return await executeApi(REPO_URL.loginFailed, BASE_API_CONSTANT.METHOD.GET, payload)
    // return await executeApi(REPO_URL.login, BASE_API_CONSTANT.METHOD.GET, payload)
    let response = await executeApi(REPO_URL.login, BASE_API_CONSTANT.METHOD.POST, payload, { isUnauthenticated: true })
    if (response?.isSuccess && response?.data) {
      LocalStorageUtils.jwtToken.set(response?.data?.token)
      return response
    }

    return response
  }

  const chooseProfile = async (roleId, profileTypeId, bankChannelId = -1, deviceId = '') => {
    const payload = {
      roleId,
      profileTypeId,
      deviceId
    }

    if (bankChannelId !== -1) payload.bankChannelId = bankChannelId

    let response = await executeApi(REPO_URL.chooseProfile, BASE_API_CONSTANT.METHOD.POST, payload)
    if (response?.isSuccess) {
      LocalStorageUtils.jwtToken.set(response?.data?.token)
      return response
    }

    return false
  }

  const logout = async () => {
    let response = await executeApi(REPO_URL.logout, BASE_API_CONSTANT.METHOD.POST)
    if (response?.isSuccess) {
      // LocalStorageUtils.all.clear()
      LocalStorageUtils.jwtToken.clear()
      return response
    }
    return response
  }

  // Assuming all imports and utility functions are available

  const checkToken = async () => {
    try {
      const response = await executeApi(REPO_URL.checkToken, BASE_API_CONSTANT.METHOD.GET)
      const isRAD = response?.data?.lstRoleDto?.id === 5

      if (!response) {
        errorToast('Not Authenticated')
        return false
      }

      if (response.isError || !response.isSuccess) {
        return response
      }

      if (isRAD) {
        setIsRoleRAD(true)
      }

      return response
    } catch (error) {
      errorToast('An error occurred while checking token')
      console.error(error)
      return false
    }
  }

  const checkTokenNoErrorShown = async () => {
    let response = await executeApiWithoutErrorShown(REPO_URL.checkToken, BASE_API_CONSTANT.METHOD.GET)
    if (!response) {
      return false
    }

    if (response?.isSuccess) {
      return response
    }
  }

  return {
    isLoading,
    data,
    error,
    login,
    chooseProfile,
    logout,
    checkToken,
    checkTokenNoErrorShown
  }
}

export default useAuthRepo
